import { render, staticRenderFns } from "./CompanyOverviewFrontComponent.vue?vue&type=template&id=aeff1f82&scoped=true"
import script from "./CompanyOverviewFrontComponent.vue?vue&type=script&lang=js"
export * from "./CompanyOverviewFrontComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeff1f82",
  null
  
)

export default component.exports